import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { Col, Container, Row, Alert, Image, Stack } from "react-bootstrap";
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { Breadcrumb, BreadcrumbDivider, BreadcrumbSection, Button, Dimmer, Icon, Label, Loader } from "semantic-ui-react";
import ProductCard from "../../component/ProductCard";
import ProductFilter from "../../component/ProductFilter";
import nodata from "../../assets/no_data.png"
import { useMyGlobal } from "../../component/GlobalData";
import { sha256 } from "../../component/utility";
//import { Blog } from "../../component/Blog";
//import { seo_meta } from '../../component/seo';
//import SeoHelmet from '../../component/SeoHelmet';

const ProductList = () => {
    const category = useLocation().state
    const path = useLocation().pathname
    const param = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const keyWords = queryParams.get('search')
    const idCustomer = (localStorage.getItem('loginDataRr') !== null) ? JSON.parse(localStorage.getItem('loginDataRr')).id : null
    const [products, setProducts] = useState([])
    const [colorList, setColorList] = useState([])
    const [brandList, setBrandList] = useState([])
    const [sizeList, setSizeList] = useState([])
    const { token } = useMyGlobal()
    const [load, setLoad] = useState(true)
    const [loadFilter, setLoadFilter] = useState(false)
    const [hideImageEmpty, setHideImageEmpty] = useState(true)
    const { wishData, isPortrait, windowWidth, categoryAll } = useMyGlobal()
    const [directLinkCat, setDirectLinkCat] = useState(null)
    const [currentPage, setCurrentPage] = useState(0)
    const pagePerLoad = 12
    const [jmlProd, setJmlProd] = useState(pagePerLoad)
    const [loaderProduct, setLoaderProduct] = useState(false)
    const [disableLoad, setDisableLoad] = useState(false)
    const [hasMore, setHasMore] = useState(true);
    const observerRef = useRef(null);
    const [originalProducts, setOriginalProducts] = useState([])
    const [listBrandbyCategoryChild, setListBrandbyCategoryChild] = useState([])

    const [filter, setFilter] = useState({
        brand: '',
        size: '',
        color: '',
        priceMin: '',
        priceMax: ''
    })

    const [sortConfig, setSortConfig] = useState({
        sort: '',
        onSale: false
    })

    const [isFirstLoad, setIsFirstLoad] = useState(true)
    
    const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const pathSegments = path
        .split('/')
        .filter(segment => segment && isNaN(Number(segment)))
        .map(segment => decodeURIComponent(segment.replace(/-/g, ' ')))

    const EmptyCategory = () => {
        return (
            <Alert variant="secondary" className="text-start mt-5">
                <Alert.Heading>This category does not contain any products!</Alert.Heading>
                <div>
                    This category does not contain items, maybe no items have been added to this category,
                    please click <Link to="/">Back to home</Link> to return to the category menu
                </div>
            </Alert>
        )
    }

    useEffect(() => {
        const handleScroll = () => {
            if (
                window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50 && !loaderProduct && hasMore
            ) {
                handleClickLoadMore();
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [loaderProduct, hasMore]);

    const getProductList = async (id_category, id_customer, option, pages, jumlahData) => {
        setLoaderProduct(true)

        const param = new URLSearchParams()
        if (id_customer === null) { id_customer = false }

        param.append('id_category', id_category)
        param.append('id_customer', id_customer)
        param.append('option', option)
        param.append('page', pages)
        param.append('limit', jumlahData)

        param.append('brand', filter.brand || '')
        param.append('size', filter.size || '')
        param.append('color', filter.color || '')
        param.append('price_min', filter.priceMin || '')
        param.append('price_max', filter.priceMax || '')

        if (category?.hasOwnProperty('search_value')) {
            param.append('param', category.search_value)
        }

        getListBrandByCategoryChild(id_category)

        await axios({
            method: "POST",
            url: `https://hoopsdevteam.com/api_web/controler/rudrunner/product.php?index=270`,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
            data: param
        })
            .then((response) => {
                let data = []
                let colors = []
                let brand = []
                let size = []

                if (response.data.state == 200) {
                    if (response.data.data.length > 0) {
                        let data = response.data.data
                        data.map((i, d) => i.color.map((x) => colors.push(x)))
                        data.map((i, d) => i.size.map((x) => size.push(x)))
                        if (category?.from !== 'parent') {
                            data.map((i, d) => i.category_parent.map((x) => brand.push(x)))
                            setBrandList(Object.values(brand.reduce((acc, item) => {
                                if (!acc[item.id_category] && item.on_page === '1') {
                                    acc[item.id_category] = {
                                        id_category: item.id_category,
                                        category_name: item.category_name,
                                        on_page: item.on_page,
                                    };
                                }
                                return acc
                            }, {})).sort((a, b) => a.category_name.localeCompare(b.category_name)))
                        } else {
                            if (category.hasOwnProperty('child')) {
                                category.child.map((i, d) => brand.push(i))
                            }
                            setBrandList(Object.values(brand.reduce((acc, item) => {
                                if (!acc[item.id_category_child]) {
                                    acc[item.id_category_child] = {
                                        id_category: item.id_category_child,
                                        category_name: item.category_name,
                                        on_page: '0',
                                    };
                                }
                                return acc
                            }, {})).sort((a, b) => a.category_name.localeCompare(b.category_name)))
                        }

                        if (response.data.data.length > 0) {
                            setLoad(false)
                            setLoadFilter(false)
                            setHideImageEmpty(true)
                        } else {
                            setLoad(false)
                            setLoadFilter(false)
                            setHideImageEmpty(false)
                        }

                        if (pages === 0) {

                            setOriginalProducts(data)
                            setProducts(applySort(data, sortConfig))

                        } else {
/*
                            setProducts(prevNew => {

                                const filteredData = data.filter(item =>
                                    !prevNew.some(prevItem => prevItem.id_product === item.id_product)
                                )

                                const merged = [...prevNew, ...filteredData]
                                return applySort(merged, sortConfig)
                            })
*/
                            setOriginalProducts(prevOriginal => {

                                const filteredData = data.filter(item =>
                                    !prevOriginal.some(prevItem => prevItem.id_product === item.id_product)
                                )

                                const merged = [...prevOriginal, ...filteredData]

                                setProducts(applySort(merged, sortConfig))

                                return merged
                            })
                        }

                        setHasMore(true)
                    } else {
                        setDisableLoad(true)
                        setHasMore(false)
                    }
                    
                    setColorList(Object.values(colors.reduce((acc, item) => {
                        if (!acc[item.id_color]) acc[item.id_color] = {
                            id_color: item.id_color,
                            color_main: item.color_main,
                            color_secondary: item.color_secondary,
                            color_accent: item.color_accent
                        }

                        return acc
                    }, {})))

                    const sizeGroup = [...new Set(size)].map(String)

                    const convertedSizeGroup = sizeGroup.map((value) => {
                        const fractionMatch = value.match(/(\d+)½/);
                        if (fractionMatch) {
                            const wholeNumber = fractionMatch[1] || '0';
                            return `${wholeNumber}.5`;
                        }

                        return value;
                    });

                    const convertedNumericGroup = sizeGroup.map((value) => {
                        const numericValue = !isNaN(parseFloat(value)) ? parseFloat(value) : value;

                        return numericValue;
                    });
                    
                    const sortableValues = convertedNumericGroup.filter(value => typeof value === 'number');
                    const nonSortableValues = convertedNumericGroup.filter(value => typeof value !== 'number');

                    const sortedNumericValues = sortableValues.sort((a, b) => a - b);

                    const finalResult = [...sortedNumericValues, ...nonSortableValues];
                    setSizeList(finalResult);
                }
            }).finally(() => {
                setLoaderProduct(false)
                setLoad(false)
                setLoadFilter(false)
            })

    }

    const handleClickLoadMore = () => {
        const page = currentPage + pagePerLoad
        setCurrentPage(page)
        getProductList(param.categoryId, idCustomer, category?.from, page, jmlProd)
    }

    useEffect(() => {

        if (category !== null) {
            setLoad(true)
            setCurrentPage(0)
            setDisableLoad(false)
            setProducts([])
            getProductList(param.categoryId, idCustomer, category?.from, 0, jmlProd)
            //document.title = category.hasOwnProperty('child') && category?.selected_child > 0 ? category.child.find(i => i.id_category_child == category.selected_child)?.category_name : category?.category_name
            window.scrollTo(0, 0)
        }
    }, [category, param])

    useEffect(() => {
        if (category === null) {
            setCurrentPage(0)
            setDisableLoad(false)
            setProducts([])
            getProductList(param.categoryId, null, 'child', 0, jmlProd)

            setDirectLinkCat(categoryAll.find(category =>
                category.child.some(child => child.id_category_child == param.categoryId)
            ))
        }
    }, [path, categoryAll, category])
    
    const getListBrandByCategoryChild = async (categoryId) => {
        await axios.get(
            "https://hoopsdevteam.com/api_web/controler/rudrunner/listbrand.php?index=1",
            {
                params: {
                    id_category_child: categoryId
                }
            }
        )
        .then(res => {
            if (res.data.state === 200) {
                setListBrandbyCategoryChild(res.data.data)
            }
        })
    }

    useEffect(() => {

        if (isFirstLoad) {
            setIsFirstLoad(false)
            return
        }

        setCurrentPage(0)
        setDisableLoad(false)
        setProducts([])
        setHasMore(true)

        getProductList(
            param.categoryId,
            idCustomer,
            category?.from ?? 'child',
            0,
            jmlProd
        )
        
        setLoadFilter(true)

    }, [filter])

    const applySort = (data, sortConfig) => {
        let sorted = [...data]

        // ON SALE
        if (sortConfig.onSale) {
            sorted.sort((a, b) => {
                const aSale = a.isDiscounted === "1" ? 1 : 0
                const bSale = b.isDiscounted === "1" ? 1 : 0

                return bSale - aSale
            })
        }

        // PRICE
        if (sortConfig.sort === 'price_low') {
            sorted.sort((a, b) => a.final_price - b.final_price)
        }

        if (sortConfig.sort === 'price_high') {
            sorted.sort((a, b) => b.final_price - a.final_price)
        }

        return sorted
    }

    useEffect(() => {

        setProducts(applySort(originalProducts, sortConfig))

    }, [sortConfig, originalProducts])
/*
    const categorySeoMap = {
        2: seo_meta.men_shoe,
        3: seo_meta.men_tshirt,
        4: seo_meta.men_jersey,
        29: seo_meta.men_pants,
        30: seo_meta.men_jacket,
        31: seo_meta.men_slide,
        6: seo_meta.kids_shoe,
        24: seo_meta.ball,
        25: seo_meta.backpack,
        26: seo_meta.cap,
        27: seo_meta.sock,
        28: seo_meta.accessories,
        33: seo_meta.headband,
        5: seo_meta.women_shoe,
        7: seo_meta.women_tshirt,
        32: seo_meta.women_jacket,
        35: seo_meta.women_slide,
        66: seo_meta.women_pants,
        34: seo_meta.wristband
    }
    const seoMeta = categorySeoMap[param.categoryId] || seo_meta.product_list

    useEffect(() => {
        document.title = seoMeta.title;

        const meta = document.querySelector(
            'meta[name="description"]'
        );

        if (meta) {
            meta.setAttribute(
            "content",
            seoMeta.description
            );
        }
    }, [category, param]);
*/
    return (
        <>

            <section>
                <div className="banner-outer">
                    <div className="banner-inner">
                        <img
                            className="img-fluid d-block w-100"
                            src={category ? category.header_image : directLinkCat ? directLinkCat.header_image : ''}
                            alt="banner"
                        />
                    </div>
                </div>
            
                <Container>
                    <Row className="mt-3 mb-3">
                        <Col xl={6} lg={12} md={12} sm={12} className="text-start">
                            <Breadcrumb size="tiny">
                                <BreadcrumbSection link onClick={() => navigate(`/`)}>HOME</BreadcrumbSection>
                                <BreadcrumbDivider />
                                <BreadcrumbSection active className="text-uppercase">
                                    { 
                                        category ?
                                        category.search_value : pathSegments[1]
                                    }
                                </BreadcrumbSection>
                            </Breadcrumb>
                        </Col>
                    </Row>
                    <Row className="mt-3 mb-3">
                        <Col xl={12} lg={12} md={12} className="text-start">
                            {category?.category_name == 'HOME' ? 
                                <h1 className="text-uppercase">{ 
                                        category ?
                                        category.search_value : "PRODUCT SEARCH"
                                    }
                                </h1> :
                                <h1>{category ? category.hasOwnProperty('child') && category?.selected_child > 0 ? category.child.find(i => i.id_category_child == category.selected_child)?.category_name : category?.category_name : directLinkCat?.child.find(c => c.id_category_child == param.categoryId)?.category_name}</h1>
                            }
                            {isMobile ? (
                                <h3 className="fw-light" style = {{textAlign: 'justify',fontSize: '0.9em' }}>
                                    {
                                        /*
                                        category 
                                            ? category?.hasOwnProperty('search_value') 
                                                ? `Search result for "${category.search_value}"`
                                                : category?.hasOwnProperty('child') && category?.selected_child > 0 
                                                    ? category.child.find(
                                                        i => i.id_category_child == category.selected_child
                                                    )?.description : category?.description
                                            : directLinkCat?.child.find(
                                                c => c.id_category_child == param.categoryId
                                            )?.description
                                        */
                                        category
                                            ? category?.hasOwnProperty('search_value')
                                                ? `Search result for "${category.search_value}"`
                                                : category?.hasOwnProperty('child')
                                                    ? category.child.find(
                                                        i => i.id_category_child == param.categoryId
                                                    )?.description || category?.description
                                                    : category?.description
                                            : directLinkCat?.child.find(
                                                c => c.id_category_child == param.categoryId
                                            )?.description

                                    }
                                </h3>
                            ):(
                                <h3 className="fs-5 fw-light" style = {{textAlign: 'justify'}}>
                                    {
                                        /*
                                        category 
                                            ? category?.hasOwnProperty('search_value') 
                                                ? `Search result for "${category.search_value}"`
                                                : category?.hasOwnProperty('child') && category?.selected_child > 0 
                                                    ? category.child.find(
                                                        i => i.id_category_child == category.selected_child
                                                    )?.description : category?.description
                                            : directLinkCat?.child.find(
                                                c => c.id_category_child == param.categoryId
                                            )?.description
                                        */
                                        category
                                            ? category?.hasOwnProperty('search_value')
                                                ? `Search result for "${category.search_value}"`
                                                : category?.hasOwnProperty('child')
                                                    ? category.child.find(
                                                        i => i.id_category_child == param.categoryId
                                                    )?.description || category?.description
                                                    : category?.description
                                            : directLinkCat?.child.find(
                                                c => c.id_category_child == param.categoryId
                                            )?.description
                                    }
                                </h3>
                            )}
                        </Col>
                    </Row>
                    {/*
                        category?.search_value !== undefined && (
                            <Row className="mb-5">
                                <Col>
                                    <Blog search={category?.search_value ?? null}/>
                                </Col>
                            </Row>
                        )
                    */}
                    <Row className="mt-1 align-items-start" style={{ padding: "0 0rem" }}>
                        {/* LEFT: FILTER */}
                        <Col xl={3} className="filter-sidebar" lg={4} md={12} style={{marginTop: '1em'}}>
                            {
                                <ProductFilter
                                    filter={filter}
                                    setFilter={setFilter}

                                    sortConfig={sortConfig}
                                    setSortConfig={setSortConfig}

                                    colorList={colorList}
                                    brandList={listBrandbyCategoryChild}
                                    sizeList={sizeList}
                                />
                            }
                        </Col>

                        {/* RIGHT: PRODUCT */}
                        <Col xl={9} lg={8} md={12}>

                            <Row style={{ paddingTop: "1em", paddingBottom: "1em" }}>
                            
                            { load && (
                                <Col xs={12} className="text-center py-5">
                                    <Loader active inline="centered" size="large">
                                        Loading Products...
                                    </Loader>
                                </Col>
                            )}
                            
                            { loadFilter && (
                                <Col xs={12} className="text-center py-5">
                                    <Loader active inline="centered" size="large">
                                        Finding Products...
                                    </Loader>
                                </Col>
                            )}

                            {
                                products?.length > 0 &&
                                products.map((item, i) => {
                                const isWish = wishData.some(w => w.id_product === item.id_product);

                                return (
                                    <ProductCard
                                    data={item}
                                    key={i}
                                    isWish={isWish}
                                    />
                                );
                                })
                            }

                            </Row>

                            {/* LOAD MORE / EMPTY */}
                            <Row className="mt-2">
                            {products.length > 0 ?
                                <Col className="text-center">
                                {
                                    hasMore ?
                                    <div className="pb-2" style={{ height: "20px", textAlign: "center" }}>
                                        {
                                        loaderProduct ?
                                            <Loader active inline size="small" />
                                            :
                                            <Icon name="angle double down" size="big" className="bounce" />
                                        }
                                    </div>
                                    :
                                    <div style={{ height: "20px", textAlign: "center" }}>
                                        <p>All product has been loaded</p>
                                    </div>
                                }
                                </Col>
                                :
                                <>
                                    {(!loadFilter && !load) && (
                                        <Col className="text-center py-5">
                                            <Stack gap={3} className="align-items-center">
                                                <Icon
                                                    name="search"
                                                    size="huge"
                                                    color="grey"
                                                />

                                                <div>
                                                    <h4 className="mb-2">
                                                        Oops! No products found.
                                                    </h4>

                                                    <p className="text-muted mb-0">
                                                        Please try adjusting your search, or feel free to explore our other products.
                                                    </p>
                                                </div>
                                            </Stack>
                                        </Col>
                                    )}
                                </>
                            }
                            </Row>

                        </Col>

                    </Row>
                </Container>
            </section>
            
        </>
    )
}

export default ProductList;